import { URL_FLAG, URL_FLAG_VALUE } from '../helpers/consts';

const FIELDS_MAP = {
    phone: 'telephone',
    email: 'email',
    first_name: 'firstName',
    last_name: 'lastName',
    middle_name: 'insertion',
    title: 'salutation',
    company: 'companyName',
    country: 'country',
    postcode: 'postalCode',
    house: 'address',
    street: 'street',
    city: 'city',
    vat: 'vatNumber',
    reference: 'source'
};

const ORDER_PARAM = 'order';
const CONTINUE_PARAM = 'continue';
const INITIAL_STEP = '0';
const PASSWORD_STEP = '3';
const OPTIN_PARAM = 'marketingOptin';
const OPTIN_VALUE = 'radio-allow';

export class UrlState {
    constructor(initialState) {
        this.enabled = false;
        this.entries = [];
        this.initialState = initialState;
        this.continue = false;

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has(URL_FLAG) && urlParams.get(URL_FLAG) === URL_FLAG_VALUE && initialState.url_prefill !== undefined) {
            this.enabled = true;
            this.entries = Object.entries(initialState.url_prefill);
        }
        if (urlParams.has(CONTINUE_PARAM)) {
            this.continue = true;
        }
    }

    alterState() {
        if (!this.enabled) {
            return this.initialState;
        }

        const alteredState = this.initialState;
        alteredState.formFields = [];
        let order = null;
        let orderItems = null;
        for (const [key, urlValue] of this.entries) {
            if ((key in FIELDS_MAP)) {
                alteredState.formFields.push({
                    id: FIELDS_MAP[key],
                    value: urlValue
                });
            } else if (key === ORDER_PARAM) {
                try {
                    order = JSON.parse(atob(urlValue));
                    orderItems = {};
                    for (const item of order) {
                        orderItems[item.I] = item.Q;
                    }
                } catch(e) {
                    console.log('Incorrect order details');
                }
            }
        }

        if (this.continue === true) {
            alteredState.steps[INITIAL_STEP].current = false;
            alteredState.steps[INITIAL_STEP].active = false;
            alteredState.steps[PASSWORD_STEP].current = true;
            alteredState.steps[PASSWORD_STEP].active = true;
        }

        // preset marketingOptin to allow
        alteredState.formFields.push({
            id: OPTIN_PARAM,
            value: OPTIN_VALUE
        });

        if (orderItems !== null) {
            // alter extras
            let index = 0;
            while (index < alteredState.extras.length) {
                if (alteredState.extras[index].id in orderItems) {
                    alteredState.extras[index].active = true;
                }
                index +=1;
            }

            // alter modules (addons)
            index = 0;
            while (index < alteredState.modules.length) {
                if (alteredState.modules[index].id in orderItems) {
                    alteredState.modules[index].active = true;
                }
                index +=1;
            }

            // alter users
            index = 0;
            while (index < alteredState.users.length) {
                if (alteredState.users[index].id in orderItems) {
                    alteredState.users[index].numberOfUsers = alteredState.users[index].numberOfFreeUsers + orderItems[alteredState.users[index].id];
                }
                index +=1;
            }
        }

        return alteredState;
    }
}

export default UrlState;
